/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BaseHit Api
 * An API for accessing data for BaseHit.com
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminActionResult,
  AdminEmailDeliveryResponse,
  BanUnbanUserRequest,
  BlogAuthorGrantRequest,
  BlogAuthorListResponse,
  CreateFreeAgentsRequest,
  CreateLeagueOptionsResponse,
  CreateLeagueRequest,
  CreateLeagueResult,
  ErrorResult,
  FeatureFlagAdminResponse,
  FeatureFlagIdsRequest,
  FeatureFlagUpdateRequest,
  GetAdminEmailDeliveryParams,
  GetAdminMessageReportsParams,
  GetAdminUserLookupParams,
  MessageReportQueueResponse,
  PostSiteAnnouncementRequest,
  ProblemDetails,
  ReleaseNoteAdminDetail,
  ReleaseNoteAdminListResponse,
  ReleaseNoteSaveRequest,
  RenameTeamRequest,
  ReportedMessageContextResponse,
  RequeueTeamFillRequest,
  RetirePlayerRequest,
  ReverseTradeRequest,
  SendMessageResponse,
  SimHealthResponse,
  SiteAnnouncement,
  SiteAnnouncementAdminListResponse,
  SiteAnnouncementCreateRequest,
  SiteAnnouncementUpdateRequest,
  SwapTeamDivisionsRequest,
  UserLookupResponse
} from '../models';

import { fetcher } from '../../fetcher';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Every site announcement, including disabled ones, newest first. Site admins only.
 */
export const getAdminAnnouncements = (

 signal?: AbortSignal
) => {


      return fetcher<SiteAnnouncementAdminListResponse>(
      {url: `/Admin/Announcements`, method: 'GET', signal
    },
      );
    }




export const getGetAdminAnnouncementsQueryKey = () => {
    return [
    `/Admin/Announcements`
    ] as const;
    }


export const getGetAdminAnnouncementsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAnnouncements>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncements>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAnnouncementsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAnnouncements>>> = ({ signal }) => getAdminAnnouncements(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminAnnouncementsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAnnouncements>>>
export type GetAdminAnnouncementsQueryError = ProblemDetails


export function useGetAdminAnnouncements<TData = Awaited<ReturnType<typeof getAdminAnnouncements>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAnnouncements>>,
          TError,
          Awaited<ReturnType<typeof getAdminAnnouncements>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAnnouncements<TData = Awaited<ReturnType<typeof getAdminAnnouncements>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAnnouncements>>,
          TError,
          Awaited<ReturnType<typeof getAdminAnnouncements>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAnnouncements<TData = Awaited<ReturnType<typeof getAdminAnnouncements>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncements>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every site announcement, including disabled ones, newest first. Site admins only.
 */

export function useGetAdminAnnouncements<TData = Awaited<ReturnType<typeof getAdminAnnouncements>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncements>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAnnouncementsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Creates a site announcement (disabled and undated to start — edit it to schedule and enable). Site admins only.
 */
export const postAdminAnnouncement = (
    siteAnnouncementCreateRequest?: SiteAnnouncementCreateRequest,
 signal?: AbortSignal
) => {


      return fetcher<SiteAnnouncement>(
      {url: `/Admin/Announcement`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: siteAnnouncementCreateRequest, signal
    },
      );
    }




export const getPostAdminAnnouncementMutationKey = () => ['postAdminAnnouncement'] as const;

export const getPostAdminAnnouncementMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminAnnouncement>>, TError,PostAdminAnnouncementMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminAnnouncement>>, TError,PostAdminAnnouncementMutationVariables, TContext> => {

const mutationKey = getPostAdminAnnouncementMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminAnnouncement>>, PostAdminAnnouncementMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postAdminAnnouncement(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminAnnouncementMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminAnnouncement>>>
    export type PostAdminAnnouncementMutationBody = SiteAnnouncementCreateRequest | undefined
    export type PostAdminAnnouncementMutationError = ErrorResult | ProblemDetails
    export type PostAdminAnnouncementMutationVariables = {data?: SiteAnnouncementCreateRequest}

    /**
 * @summary Creates a site announcement (disabled and undated to start — edit it to schedule and enable). Site admins only.
 */
export const usePostAdminAnnouncement = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminAnnouncement>>, TError,PostAdminAnnouncementMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminAnnouncement>>,
        TError,
        PostAdminAnnouncementMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminAnnouncementMutationOptions(options), queryClient);
    }
    /**
 * @summary Updates a site announcement. A null postOn clears the post date. Site admins only.
 */
export const putAdminAnnouncementId = (
    id: number,
    siteAnnouncementUpdateRequest?: SiteAnnouncementUpdateRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Admin/Announcement/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: siteAnnouncementUpdateRequest, signal
    },
      );
    }




export const getPutAdminAnnouncementIdMutationKey = () => ['putAdminAnnouncementId'] as const;

export const getPutAdminAnnouncementIdMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminAnnouncementId>>, TError,PutAdminAnnouncementIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminAnnouncementId>>, TError,PutAdminAnnouncementIdMutationVariables, TContext> => {

const mutationKey = getPutAdminAnnouncementIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminAnnouncementId>>, PutAdminAnnouncementIdMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminAnnouncementId(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutAdminAnnouncementIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminAnnouncementId>>>
    export type PutAdminAnnouncementIdMutationBody = SiteAnnouncementUpdateRequest | undefined
    export type PutAdminAnnouncementIdMutationError = ErrorResult | ProblemDetails
    export type PutAdminAnnouncementIdMutationVariables = {id: number;data?: SiteAnnouncementUpdateRequest}

    /**
 * @summary Updates a site announcement. A null postOn clears the post date. Site admins only.
 */
export const usePutAdminAnnouncementId = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminAnnouncementId>>, TError,PutAdminAnnouncementIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminAnnouncementId>>,
        TError,
        PutAdminAnnouncementIdMutationVariables,
        TContext
      > => {
      return useMutation(getPutAdminAnnouncementIdMutationOptions(options), queryClient);
    }
    /**
 * @summary Deletes a site announcement. Site admins only.
 */
export const deleteAdminAnnouncementId = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Admin/Announcement/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAdminAnnouncementIdMutationKey = () => ['deleteAdminAnnouncementId'] as const;

export const getDeleteAdminAnnouncementIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminAnnouncementId>>, TError,DeleteAdminAnnouncementIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminAnnouncementId>>, TError,DeleteAdminAnnouncementIdMutationVariables, TContext> => {

const mutationKey = getDeleteAdminAnnouncementIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminAnnouncementId>>, DeleteAdminAnnouncementIdMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminAnnouncementId(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminAnnouncementIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminAnnouncementId>>>

    export type DeleteAdminAnnouncementIdMutationError = ProblemDetails
    export type DeleteAdminAnnouncementIdMutationVariables = {id: number}

    /**
 * @summary Deletes a site announcement. Site admins only.
 */
export const useDeleteAdminAnnouncementId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminAnnouncementId>>, TError,DeleteAdminAnnouncementIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminAnnouncementId>>,
        TError,
        DeleteAdminAnnouncementIdMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAdminAnnouncementIdMutationOptions(options), queryClient);
    }
    /**
 * @summary Posts to the site announcements message thread, which every active user receives in
Messages. Not repliable by anyone. Site admins only. (Separate from the dashboard
banner managed by the endpoints above.)
 */
export const postAdminSiteAnnouncementPost = (
    postSiteAnnouncementRequest?: PostSiteAnnouncementRequest,
 signal?: AbortSignal
) => {


      return fetcher<SendMessageResponse>(
      {url: `/Admin/SiteAnnouncementPost`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSiteAnnouncementRequest, signal
    },
      );
    }




export const getPostAdminSiteAnnouncementPostMutationKey = () => ['postAdminSiteAnnouncementPost'] as const;

export const getPostAdminSiteAnnouncementPostMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminSiteAnnouncementPost>>, TError,PostAdminSiteAnnouncementPostMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminSiteAnnouncementPost>>, TError,PostAdminSiteAnnouncementPostMutationVariables, TContext> => {

const mutationKey = getPostAdminSiteAnnouncementPostMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminSiteAnnouncementPost>>, PostAdminSiteAnnouncementPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postAdminSiteAnnouncementPost(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminSiteAnnouncementPostMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminSiteAnnouncementPost>>>
    export type PostAdminSiteAnnouncementPostMutationBody = PostSiteAnnouncementRequest | undefined
    export type PostAdminSiteAnnouncementPostMutationError = ErrorResult | ProblemDetails
    export type PostAdminSiteAnnouncementPostMutationVariables = {data?: PostSiteAnnouncementRequest}

    /**
 * @summary Posts to the site announcements message thread, which every active user receives in
Messages. Not repliable by anyone. Site admins only. (Separate from the dashboard
banner managed by the endpoints above.)
 */
export const usePostAdminSiteAnnouncementPost = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminSiteAnnouncementPost>>, TError,PostAdminSiteAnnouncementPostMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminSiteAnnouncementPost>>,
        TError,
        PostAdminSiteAnnouncementPostMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminSiteAnnouncementPostMutationOptions(options), queryClient);
    }
    /**
 * @summary All blog authors on the allowlist. Site admins only.
 */
export const getAdminBlogAuthors = (

 signal?: AbortSignal
) => {


      return fetcher<BlogAuthorListResponse>(
      {url: `/Admin/BlogAuthors`, method: 'GET', signal
    },
      );
    }




export const getGetAdminBlogAuthorsQueryKey = () => {
    return [
    `/Admin/BlogAuthors`
    ] as const;
    }


export const getGetAdminBlogAuthorsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminBlogAuthors>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminBlogAuthors>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminBlogAuthorsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminBlogAuthors>>> = ({ signal }) => getAdminBlogAuthors(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminBlogAuthors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminBlogAuthorsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminBlogAuthors>>>
export type GetAdminBlogAuthorsQueryError = unknown


export function useGetAdminBlogAuthors<TData = Awaited<ReturnType<typeof getAdminBlogAuthors>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminBlogAuthors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminBlogAuthors>>,
          TError,
          Awaited<ReturnType<typeof getAdminBlogAuthors>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminBlogAuthors<TData = Awaited<ReturnType<typeof getAdminBlogAuthors>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminBlogAuthors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminBlogAuthors>>,
          TError,
          Awaited<ReturnType<typeof getAdminBlogAuthors>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminBlogAuthors<TData = Awaited<ReturnType<typeof getAdminBlogAuthors>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminBlogAuthors>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary All blog authors on the allowlist. Site admins only.
 */

export function useGetAdminBlogAuthors<TData = Awaited<ReturnType<typeof getAdminBlogAuthors>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminBlogAuthors>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminBlogAuthorsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Grants a user blog authorship. Site admins only.
 */
export const postAdminBlogAuthors = (
    blogAuthorGrantRequest?: BlogAuthorGrantRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Admin/BlogAuthors`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: blogAuthorGrantRequest, signal
    },
      );
    }




export const getPostAdminBlogAuthorsMutationKey = () => ['postAdminBlogAuthors'] as const;

export const getPostAdminBlogAuthorsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminBlogAuthors>>, TError,PostAdminBlogAuthorsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminBlogAuthors>>, TError,PostAdminBlogAuthorsMutationVariables, TContext> => {

const mutationKey = getPostAdminBlogAuthorsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminBlogAuthors>>, PostAdminBlogAuthorsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postAdminBlogAuthors(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminBlogAuthorsMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminBlogAuthors>>>
    export type PostAdminBlogAuthorsMutationBody = BlogAuthorGrantRequest | undefined
    export type PostAdminBlogAuthorsMutationError = ProblemDetails
    export type PostAdminBlogAuthorsMutationVariables = {data?: BlogAuthorGrantRequest}

    /**
 * @summary Grants a user blog authorship. Site admins only.
 */
export const usePostAdminBlogAuthors = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminBlogAuthors>>, TError,PostAdminBlogAuthorsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminBlogAuthors>>,
        TError,
        PostAdminBlogAuthorsMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminBlogAuthorsMutationOptions(options), queryClient);
    }
    /**
 * @summary Revokes authorship. The user's published posts are deliberately left alone —
removing someone's ability to write is not a decision to retract what they wrote.
 */
export const deleteAdminBlogAuthorsUserId = (
    userId: number,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Admin/BlogAuthors/${userId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAdminBlogAuthorsUserIdMutationKey = () => ['deleteAdminBlogAuthorsUserId'] as const;

export const getDeleteAdminBlogAuthorsUserIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminBlogAuthorsUserId>>, TError,DeleteAdminBlogAuthorsUserIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminBlogAuthorsUserId>>, TError,DeleteAdminBlogAuthorsUserIdMutationVariables, TContext> => {

const mutationKey = getDeleteAdminBlogAuthorsUserIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminBlogAuthorsUserId>>, DeleteAdminBlogAuthorsUserIdMutationVariables> = (props) => {
          const {userId} = props ?? {};

          return  deleteAdminBlogAuthorsUserId(userId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminBlogAuthorsUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminBlogAuthorsUserId>>>

    export type DeleteAdminBlogAuthorsUserIdMutationError = ProblemDetails
    export type DeleteAdminBlogAuthorsUserIdMutationVariables = {userId: number}

    /**
 * @summary Revokes authorship. The user's published posts are deliberately left alone —
removing someone's ability to write is not a decision to retract what they wrote.
 */
export const useDeleteAdminBlogAuthorsUserId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminBlogAuthorsUserId>>, TError,DeleteAdminBlogAuthorsUserIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminBlogAuthorsUserId>>,
        TError,
        DeleteAdminBlogAuthorsUserIdMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAdminBlogAuthorsUserIdMutationOptions(options), queryClient);
    }
    /**
 * @summary User/IP investigative lookup. Provide exactly one of username / ipAddress.
deep (username only) also returns, per IP, the OTHER users seen on it (alt-account catch).
Site admins or community managers.
 */
export const getAdminUserLookup = (
    params?: GetAdminUserLookupParams,
 signal?: AbortSignal
) => {


      return fetcher<UserLookupResponse>(
      {url: `/Admin/UserLookup`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetAdminUserLookupQueryKey = (params?: GetAdminUserLookupParams,) => {
    return [
    `/Admin/UserLookup`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminUserLookupQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUserLookup>>, TError = ErrorResult | ProblemDetails>(params?: GetAdminUserLookupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUserLookup>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUserLookupQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUserLookup>>> = ({ signal }) => getAdminUserLookup(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUserLookup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminUserLookupQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUserLookup>>>
export type GetAdminUserLookupQueryError = ErrorResult | ProblemDetails


export function useGetAdminUserLookup<TData = Awaited<ReturnType<typeof getAdminUserLookup>>, TError = ErrorResult | ProblemDetails>(
 params: undefined |  GetAdminUserLookupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUserLookup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUserLookup>>,
          TError,
          Awaited<ReturnType<typeof getAdminUserLookup>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUserLookup<TData = Awaited<ReturnType<typeof getAdminUserLookup>>, TError = ErrorResult | ProblemDetails>(
 params?: GetAdminUserLookupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUserLookup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUserLookup>>,
          TError,
          Awaited<ReturnType<typeof getAdminUserLookup>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUserLookup<TData = Awaited<ReturnType<typeof getAdminUserLookup>>, TError = ErrorResult | ProblemDetails>(
 params?: GetAdminUserLookupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUserLookup>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary User/IP investigative lookup. Provide exactly one of username / ipAddress.
deep (username only) also returns, per IP, the OTHER users seen on it (alt-account catch).
Site admins or community managers.
 */

export function useGetAdminUserLookup<TData = Awaited<ReturnType<typeof getAdminUserLookup>>, TError = ErrorResult | ProblemDetails>(
 params?: GetAdminUserLookupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUserLookup>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminUserLookupQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Email delivery health: SendGrid suppressions (from the nightly sync) and exhausted send failures.
Site admins only — it lists users' email addresses.
 */
export const getAdminEmailDelivery = (
    params?: GetAdminEmailDeliveryParams,
 signal?: AbortSignal
) => {


      return fetcher<AdminEmailDeliveryResponse>(
      {url: `/Admin/EmailDelivery`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetAdminEmailDeliveryQueryKey = (params?: GetAdminEmailDeliveryParams,) => {
    return [
    `/Admin/EmailDelivery`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminEmailDeliveryQueryOptions = <TData = Awaited<ReturnType<typeof getAdminEmailDelivery>>, TError = ProblemDetails>(params?: GetAdminEmailDeliveryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmailDelivery>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminEmailDeliveryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminEmailDelivery>>> = ({ signal }) => getAdminEmailDelivery(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminEmailDelivery>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminEmailDeliveryQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminEmailDelivery>>>
export type GetAdminEmailDeliveryQueryError = ProblemDetails


export function useGetAdminEmailDelivery<TData = Awaited<ReturnType<typeof getAdminEmailDelivery>>, TError = ProblemDetails>(
 params: undefined |  GetAdminEmailDeliveryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmailDelivery>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmailDelivery>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmailDelivery>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmailDelivery<TData = Awaited<ReturnType<typeof getAdminEmailDelivery>>, TError = ProblemDetails>(
 params?: GetAdminEmailDeliveryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmailDelivery>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmailDelivery>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmailDelivery>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmailDelivery<TData = Awaited<ReturnType<typeof getAdminEmailDelivery>>, TError = ProblemDetails>(
 params?: GetAdminEmailDeliveryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmailDelivery>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Email delivery health: SendGrid suppressions (from the nightly sync) and exhausted send failures.
Site admins only — it lists users' email addresses.
 */

export function useGetAdminEmailDelivery<TData = Awaited<ReturnType<typeof getAdminEmailDelivery>>, TError = ProblemDetails>(
 params?: GetAdminEmailDeliveryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmailDelivery>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminEmailDeliveryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary All feature flags with their targeting rules + orphan status. Site admins only.
 */
export const getAdminFeatureFlags = (

 signal?: AbortSignal
) => {


      return fetcher<FeatureFlagAdminResponse>(
      {url: `/Admin/FeatureFlags`, method: 'GET', signal
    },
      );
    }




export const getGetAdminFeatureFlagsQueryKey = () => {
    return [
    `/Admin/FeatureFlags`
    ] as const;
    }


export const getGetAdminFeatureFlagsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFeatureFlags>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFeatureFlags>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFeatureFlagsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFeatureFlags>>> = ({ signal }) => getAdminFeatureFlags(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFeatureFlags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFeatureFlags>>>
export type GetAdminFeatureFlagsQueryError = ProblemDetails


export function useGetAdminFeatureFlags<TData = Awaited<ReturnType<typeof getAdminFeatureFlags>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFeatureFlags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeatureFlags>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFeatureFlags<TData = Awaited<ReturnType<typeof getAdminFeatureFlags>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFeatureFlags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof getAdminFeatureFlags>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFeatureFlags<TData = Awaited<ReturnType<typeof getAdminFeatureFlags>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFeatureFlags>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary All feature flags with their targeting rules + orphan status. Site admins only.
 */

export function useGetAdminFeatureFlags<TData = Awaited<ReturnType<typeof getAdminFeatureFlags>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFeatureFlags>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminFeatureFlagsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create/update a flag's settings (global/admins-only/description). Site admins only.
 */
export const putAdminFeatureFlagsKey = (
    key: string,
    featureFlagUpdateRequest?: FeatureFlagUpdateRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Admin/FeatureFlags/${key}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureFlagUpdateRequest, signal
    },
      );
    }




export const getPutAdminFeatureFlagsKeyMutationKey = () => ['putAdminFeatureFlagsKey'] as const;

export const getPutAdminFeatureFlagsKeyMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminFeatureFlagsKey>>, TError,PutAdminFeatureFlagsKeyMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminFeatureFlagsKey>>, TError,PutAdminFeatureFlagsKeyMutationVariables, TContext> => {

const mutationKey = getPutAdminFeatureFlagsKeyMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminFeatureFlagsKey>>, PutAdminFeatureFlagsKeyMutationVariables> = (props) => {
          const {key,data} = props ?? {};

          return  putAdminFeatureFlagsKey(key,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutAdminFeatureFlagsKeyMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminFeatureFlagsKey>>>
    export type PutAdminFeatureFlagsKeyMutationBody = FeatureFlagUpdateRequest | undefined
    export type PutAdminFeatureFlagsKeyMutationError = ErrorResult | ProblemDetails
    export type PutAdminFeatureFlagsKeyMutationVariables = {key: string;data?: FeatureFlagUpdateRequest}

    /**
 * @summary Create/update a flag's settings (global/admins-only/description). Site admins only.
 */
export const usePutAdminFeatureFlagsKey = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminFeatureFlagsKey>>, TError,PutAdminFeatureFlagsKeyMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminFeatureFlagsKey>>,
        TError,
        PutAdminFeatureFlagsKeyMutationVariables,
        TContext
      > => {
      return useMutation(getPutAdminFeatureFlagsKeyMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete a flag (typically an orphan). Site admins only.
 */
export const deleteAdminFeatureFlagsKey = (
    key: string,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Admin/FeatureFlags/${key}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAdminFeatureFlagsKeyMutationKey = () => ['deleteAdminFeatureFlagsKey'] as const;

export const getDeleteAdminFeatureFlagsKeyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminFeatureFlagsKey>>, TError,DeleteAdminFeatureFlagsKeyMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminFeatureFlagsKey>>, TError,DeleteAdminFeatureFlagsKeyMutationVariables, TContext> => {

const mutationKey = getDeleteAdminFeatureFlagsKeyMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminFeatureFlagsKey>>, DeleteAdminFeatureFlagsKeyMutationVariables> = (props) => {
          const {key} = props ?? {};

          return  deleteAdminFeatureFlagsKey(key,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminFeatureFlagsKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminFeatureFlagsKey>>>

    export type DeleteAdminFeatureFlagsKeyMutationError = ProblemDetails
    export type DeleteAdminFeatureFlagsKeyMutationVariables = {key: string}

    /**
 * @summary Delete a flag (typically an orphan). Site admins only.
 */
export const useDeleteAdminFeatureFlagsKey = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminFeatureFlagsKey>>, TError,DeleteAdminFeatureFlagsKeyMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminFeatureFlagsKey>>,
        TError,
        DeleteAdminFeatureFlagsKeyMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAdminFeatureFlagsKeyMutationOptions(options), queryClient);
    }
    /**
 * @summary Replace a flag's league rollout group. Rejects unknown league IDs. Site admins only.
 */
export const putAdminFeatureFlagsKeyLeagues = (
    key: string,
    featureFlagIdsRequest?: FeatureFlagIdsRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Admin/FeatureFlags/${key}/Leagues`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureFlagIdsRequest, signal
    },
      );
    }




export const getPutAdminFeatureFlagsKeyLeaguesMutationKey = () => ['putAdminFeatureFlagsKeyLeagues'] as const;

export const getPutAdminFeatureFlagsKeyLeaguesMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminFeatureFlagsKeyLeagues>>, TError,PutAdminFeatureFlagsKeyLeaguesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminFeatureFlagsKeyLeagues>>, TError,PutAdminFeatureFlagsKeyLeaguesMutationVariables, TContext> => {

const mutationKey = getPutAdminFeatureFlagsKeyLeaguesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminFeatureFlagsKeyLeagues>>, PutAdminFeatureFlagsKeyLeaguesMutationVariables> = (props) => {
          const {key,data} = props ?? {};

          return  putAdminFeatureFlagsKeyLeagues(key,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutAdminFeatureFlagsKeyLeaguesMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminFeatureFlagsKeyLeagues>>>
    export type PutAdminFeatureFlagsKeyLeaguesMutationBody = FeatureFlagIdsRequest | undefined
    export type PutAdminFeatureFlagsKeyLeaguesMutationError = ErrorResult | ProblemDetails
    export type PutAdminFeatureFlagsKeyLeaguesMutationVariables = {key: string;data?: FeatureFlagIdsRequest}

    /**
 * @summary Replace a flag's league rollout group. Rejects unknown league IDs. Site admins only.
 */
export const usePutAdminFeatureFlagsKeyLeagues = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminFeatureFlagsKeyLeagues>>, TError,PutAdminFeatureFlagsKeyLeaguesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminFeatureFlagsKeyLeagues>>,
        TError,
        PutAdminFeatureFlagsKeyLeaguesMutationVariables,
        TContext
      > => {
      return useMutation(getPutAdminFeatureFlagsKeyLeaguesMutationOptions(options), queryClient);
    }
    /**
 * @summary Replace a flag's early-access user list. Rejects unknown user IDs. Site admins only.
 */
export const putAdminFeatureFlagsKeyUsers = (
    key: string,
    featureFlagIdsRequest?: FeatureFlagIdsRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Admin/FeatureFlags/${key}/Users`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureFlagIdsRequest, signal
    },
      );
    }




export const getPutAdminFeatureFlagsKeyUsersMutationKey = () => ['putAdminFeatureFlagsKeyUsers'] as const;

export const getPutAdminFeatureFlagsKeyUsersMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminFeatureFlagsKeyUsers>>, TError,PutAdminFeatureFlagsKeyUsersMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminFeatureFlagsKeyUsers>>, TError,PutAdminFeatureFlagsKeyUsersMutationVariables, TContext> => {

const mutationKey = getPutAdminFeatureFlagsKeyUsersMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminFeatureFlagsKeyUsers>>, PutAdminFeatureFlagsKeyUsersMutationVariables> = (props) => {
          const {key,data} = props ?? {};

          return  putAdminFeatureFlagsKeyUsers(key,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutAdminFeatureFlagsKeyUsersMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminFeatureFlagsKeyUsers>>>
    export type PutAdminFeatureFlagsKeyUsersMutationBody = FeatureFlagIdsRequest | undefined
    export type PutAdminFeatureFlagsKeyUsersMutationError = ErrorResult | ProblemDetails
    export type PutAdminFeatureFlagsKeyUsersMutationVariables = {key: string;data?: FeatureFlagIdsRequest}

    /**
 * @summary Replace a flag's early-access user list. Rejects unknown user IDs. Site admins only.
 */
export const usePutAdminFeatureFlagsKeyUsers = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminFeatureFlagsKeyUsers>>, TError,PutAdminFeatureFlagsKeyUsersMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminFeatureFlagsKeyUsers>>,
        TError,
        PutAdminFeatureFlagsKeyUsersMutationVariables,
        TContext
      > => {
      return useMutation(getPutAdminFeatureFlagsKeyUsersMutationOptions(options), queryClient);
    }
    /**
 * @summary Form options for the admin Create League tool: the legal franchise shapes, active
            sim models, and the salary-cap ladder plus its server-computed defaults. Site admins only.
 */
export const getAdminCreateLeagueOptions = (

 signal?: AbortSignal
) => {


      return fetcher<CreateLeagueOptionsResponse>(
      {url: `/Admin/CreateLeague/Options`, method: 'GET', signal
    },
      );
    }




export const getGetAdminCreateLeagueOptionsQueryKey = () => {
    return [
    `/Admin/CreateLeague/Options`
    ] as const;
    }


export const getGetAdminCreateLeagueOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>, TError = ErrorResult | ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminCreateLeagueOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>> = ({ signal }) => getAdminCreateLeagueOptions(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminCreateLeagueOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>>
export type GetAdminCreateLeagueOptionsQueryError = ErrorResult | ProblemDetails


export function useGetAdminCreateLeagueOptions<TData = Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>, TError = ErrorResult | ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>,
          TError,
          Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminCreateLeagueOptions<TData = Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>, TError = ErrorResult | ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>,
          TError,
          Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminCreateLeagueOptions<TData = Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>, TError = ErrorResult | ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Form options for the admin Create League tool: the legal franchise shapes, active
            sim models, and the salary-cap ladder plus its server-computed defaults. Site admins only.
 */

export function useGetAdminCreateLeagueOptions<TData = Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>, TError = ErrorResult | ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreateLeagueOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminCreateLeagueOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Creates a franchise league with every setting decided up front, optionally filling
            it with unowned teams. Site admins only.
 */
export const postAdminCreateLeague = (
    createLeagueRequest?: CreateLeagueRequest,
 signal?: AbortSignal
) => {


      return fetcher<CreateLeagueResult>(
      {url: `/Admin/CreateLeague`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLeagueRequest, signal
    },
      );
    }




export const getPostAdminCreateLeagueMutationKey = () => ['postAdminCreateLeague'] as const;

export const getPostAdminCreateLeagueMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreateLeague>>, TError,PostAdminCreateLeagueMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminCreateLeague>>, TError,PostAdminCreateLeagueMutationVariables, TContext> => {

const mutationKey = getPostAdminCreateLeagueMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminCreateLeague>>, PostAdminCreateLeagueMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postAdminCreateLeague(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminCreateLeagueMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminCreateLeague>>>
    export type PostAdminCreateLeagueMutationBody = CreateLeagueRequest | undefined
    export type PostAdminCreateLeagueMutationError = ErrorResult | ProblemDetails
    export type PostAdminCreateLeagueMutationVariables = {data?: CreateLeagueRequest}

    /**
 * @summary Creates a franchise league with every setting decided up front, optionally filling
            it with unowned teams. Site admins only.
 */
export const usePostAdminCreateLeague = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreateLeague>>, TError,PostAdminCreateLeagueMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminCreateLeague>>,
        TError,
        PostAdminCreateLeagueMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminCreateLeagueMutationOptions(options), queryClient);
    }
    /**
 * @summary Re-drives the background unowned-team fill for an existing league whose
            original run was abandoned (a Functions deploy, a host restart, or a poisoned message).
            Rejects a non-franchise league, a league whose status doesn't allow team creation, or a
            league already at capacity. A recovery action, not the creation form. Site admins only.
 */
export const postAdminCreateLeagueRequeueTeamFill = (
    requeueTeamFillRequest?: RequeueTeamFillRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Admin/CreateLeague/RequeueTeamFill`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requeueTeamFillRequest, signal
    },
      );
    }




export const getPostAdminCreateLeagueRequeueTeamFillMutationKey = () => ['postAdminCreateLeagueRequeueTeamFill'] as const;

export const getPostAdminCreateLeagueRequeueTeamFillMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreateLeagueRequeueTeamFill>>, TError,PostAdminCreateLeagueRequeueTeamFillMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminCreateLeagueRequeueTeamFill>>, TError,PostAdminCreateLeagueRequeueTeamFillMutationVariables, TContext> => {

const mutationKey = getPostAdminCreateLeagueRequeueTeamFillMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminCreateLeagueRequeueTeamFill>>, PostAdminCreateLeagueRequeueTeamFillMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postAdminCreateLeagueRequeueTeamFill(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminCreateLeagueRequeueTeamFillMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminCreateLeagueRequeueTeamFill>>>
    export type PostAdminCreateLeagueRequeueTeamFillMutationBody = RequeueTeamFillRequest | undefined
    export type PostAdminCreateLeagueRequeueTeamFillMutationError = ErrorResult | ProblemDetails
    export type PostAdminCreateLeagueRequeueTeamFillMutationVariables = {data?: RequeueTeamFillRequest}

    /**
 * @summary Re-drives the background unowned-team fill for an existing league whose
            original run was abandoned (a Functions deploy, a host restart, or a poisoned message).
            Rejects a non-franchise league, a league whose status doesn't allow team creation, or a
            league already at capacity. A recovery action, not the creation form. Site admins only.
 */
export const usePostAdminCreateLeagueRequeueTeamFill = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreateLeagueRequeueTeamFill>>, TError,PostAdminCreateLeagueRequeueTeamFillMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminCreateLeagueRequeueTeamFill>>,
        TError,
        PostAdminCreateLeagueRequeueTeamFillMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminCreateLeagueRequeueTeamFillMutationOptions(options), queryClient);
    }
    /**
 * @summary Message-report review queue (reported direct messages + league announcements).
Defaults to pending-only; pass includeReviewed=true for the full history.
Site admins or community managers.
 */
export const getAdminMessageReports = (
    params?: GetAdminMessageReportsParams,
 signal?: AbortSignal
) => {


      return fetcher<MessageReportQueueResponse>(
      {url: `/Admin/MessageReports`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetAdminMessageReportsQueryKey = (params?: GetAdminMessageReportsParams,) => {
    return [
    `/Admin/MessageReports`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminMessageReportsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMessageReports>>, TError = ProblemDetails>(params?: GetAdminMessageReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessageReports>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMessageReportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMessageReports>>> = ({ signal }) => getAdminMessageReports(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMessageReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMessageReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMessageReports>>>
export type GetAdminMessageReportsQueryError = ProblemDetails


export function useGetAdminMessageReports<TData = Awaited<ReturnType<typeof getAdminMessageReports>>, TError = ProblemDetails>(
 params: undefined |  GetAdminMessageReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessageReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMessageReports>>,
          TError,
          Awaited<ReturnType<typeof getAdminMessageReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMessageReports<TData = Awaited<ReturnType<typeof getAdminMessageReports>>, TError = ProblemDetails>(
 params?: GetAdminMessageReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessageReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMessageReports>>,
          TError,
          Awaited<ReturnType<typeof getAdminMessageReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMessageReports<TData = Awaited<ReturnType<typeof getAdminMessageReports>>, TError = ProblemDetails>(
 params?: GetAdminMessageReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessageReports>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Message-report review queue (reported direct messages + league announcements).
Defaults to pending-only; pass includeReviewed=true for the full history.
Site admins or community managers.
 */

export function useGetAdminMessageReports<TData = Awaited<ReturnType<typeof getAdminMessageReports>>, TError = ProblemDetails>(
 params?: GetAdminMessageReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessageReports>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMessageReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Full conversation context surrounding a reported message. Site admins or community managers.
 */
export const getAdminMessageReportsReportIdContext = (
    reportId: number,
 signal?: AbortSignal
) => {


      return fetcher<ReportedMessageContextResponse>(
      {url: `/Admin/MessageReports/${reportId}/Context`, method: 'GET', signal
    },
      );
    }




export const getGetAdminMessageReportsReportIdContextQueryKey = (reportId: number,) => {
    return [
    `/Admin/MessageReports/${reportId}/Context`
    ] as const;
    }


export const getGetAdminMessageReportsReportIdContextQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>, TError = ProblemDetails>(reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMessageReportsReportIdContextQueryKey(reportId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>> = ({ signal }) => getAdminMessageReportsReportIdContext(reportId, signal);





   return  { queryKey, queryFn, enabled: reportId !== null && reportId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMessageReportsReportIdContextQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>>
export type GetAdminMessageReportsReportIdContextQueryError = ProblemDetails


export function useGetAdminMessageReportsReportIdContext<TData = Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>, TError = ProblemDetails>(
 reportId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>,
          TError,
          Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMessageReportsReportIdContext<TData = Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>, TError = ProblemDetails>(
 reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>,
          TError,
          Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMessageReportsReportIdContext<TData = Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>, TError = ProblemDetails>(
 reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Full conversation context surrounding a reported message. Site admins or community managers.
 */

export function useGetAdminMessageReportsReportIdContext<TData = Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>, TError = ProblemDetails>(
 reportId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessageReportsReportIdContext>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMessageReportsReportIdContextQueryOptions(reportId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Marks a message report reviewed (dbo.MessageReportReview). Site admins or community managers.
 */
export const postAdminMessageReportsReportIdReview = (
    reportId: number,
 signal?: AbortSignal
) => {


      return fetcher<AdminActionResult>(
      {url: `/Admin/MessageReports/${reportId}/Review`, method: 'POST', signal
    },
      );
    }




export const getPostAdminMessageReportsReportIdReviewMutationKey = () => ['postAdminMessageReportsReportIdReview'] as const;

export const getPostAdminMessageReportsReportIdReviewMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminMessageReportsReportIdReview>>, TError,PostAdminMessageReportsReportIdReviewMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminMessageReportsReportIdReview>>, TError,PostAdminMessageReportsReportIdReviewMutationVariables, TContext> => {

const mutationKey = getPostAdminMessageReportsReportIdReviewMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminMessageReportsReportIdReview>>, PostAdminMessageReportsReportIdReviewMutationVariables> = (props) => {
          const {reportId} = props ?? {};

          return  postAdminMessageReportsReportIdReview(reportId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminMessageReportsReportIdReviewMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminMessageReportsReportIdReview>>>

    export type PostAdminMessageReportsReportIdReviewMutationError = ProblemDetails
    export type PostAdminMessageReportsReportIdReviewMutationVariables = {reportId: number}

    /**
 * @summary Marks a message report reviewed (dbo.MessageReportReview). Site admins or community managers.
 */
export const usePostAdminMessageReportsReportIdReview = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminMessageReportsReportIdReview>>, TError,PostAdminMessageReportsReportIdReviewMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminMessageReportsReportIdReview>>,
        TError,
        PostAdminMessageReportsReportIdReviewMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminMessageReportsReportIdReviewMutationOptions(options), queryClient);
    }
    /**
 * @summary Reverses a completed trade (dbo.TradeReverse). Site admins or community managers.
 */
export const postAdminReverseTrade = (
    reverseTradeRequest?: ReverseTradeRequest,
 signal?: AbortSignal
) => {


      return fetcher<AdminActionResult>(
      {url: `/Admin/ReverseTrade`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reverseTradeRequest, signal
    },
      );
    }




export const getPostAdminReverseTradeMutationKey = () => ['postAdminReverseTrade'] as const;

export const getPostAdminReverseTradeMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminReverseTrade>>, TError,PostAdminReverseTradeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminReverseTrade>>, TError,PostAdminReverseTradeMutationVariables, TContext> => {

const mutationKey = getPostAdminReverseTradeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminReverseTrade>>, PostAdminReverseTradeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postAdminReverseTrade(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminReverseTradeMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminReverseTrade>>>
    export type PostAdminReverseTradeMutationBody = ReverseTradeRequest | undefined
    export type PostAdminReverseTradeMutationError = ErrorResult | ProblemDetails
    export type PostAdminReverseTradeMutationVariables = {data?: ReverseTradeRequest}

    /**
 * @summary Reverses a completed trade (dbo.TradeReverse). Site admins or community managers.
 */
export const usePostAdminReverseTrade = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminReverseTrade>>, TError,PostAdminReverseTradeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminReverseTrade>>,
        TError,
        PostAdminReverseTradeMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminReverseTradeMutationOptions(options), queryClient);
    }
    /**
 * @summary Force-retires a player (dbo.PlayerRetire). Site admins or community managers.
 */
export const postAdminRetirePlayer = (
    retirePlayerRequest?: RetirePlayerRequest,
 signal?: AbortSignal
) => {


      return fetcher<AdminActionResult>(
      {url: `/Admin/RetirePlayer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: retirePlayerRequest, signal
    },
      );
    }




export const getPostAdminRetirePlayerMutationKey = () => ['postAdminRetirePlayer'] as const;

export const getPostAdminRetirePlayerMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRetirePlayer>>, TError,PostAdminRetirePlayerMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminRetirePlayer>>, TError,PostAdminRetirePlayerMutationVariables, TContext> => {

const mutationKey = getPostAdminRetirePlayerMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminRetirePlayer>>, PostAdminRetirePlayerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postAdminRetirePlayer(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminRetirePlayerMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminRetirePlayer>>>
    export type PostAdminRetirePlayerMutationBody = RetirePlayerRequest | undefined
    export type PostAdminRetirePlayerMutationError = ErrorResult | ProblemDetails
    export type PostAdminRetirePlayerMutationVariables = {data?: RetirePlayerRequest}

    /**
 * @summary Force-retires a player (dbo.PlayerRetire). Site admins or community managers.
 */
export const usePostAdminRetirePlayer = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRetirePlayer>>, TError,PostAdminRetirePlayerMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminRetirePlayer>>,
        TError,
        PostAdminRetirePlayerMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminRetirePlayerMutationOptions(options), queryClient);
    }
    /**
 * @summary Bans or unbans a user (dbo.CMBanUnbanUser). Site admins or community managers.
 */
export const postAdminBanUnbanUser = (
    banUnbanUserRequest?: BanUnbanUserRequest,
 signal?: AbortSignal
) => {


      return fetcher<AdminActionResult>(
      {url: `/Admin/BanUnbanUser`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: banUnbanUserRequest, signal
    },
      );
    }




export const getPostAdminBanUnbanUserMutationKey = () => ['postAdminBanUnbanUser'] as const;

export const getPostAdminBanUnbanUserMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminBanUnbanUser>>, TError,PostAdminBanUnbanUserMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminBanUnbanUser>>, TError,PostAdminBanUnbanUserMutationVariables, TContext> => {

const mutationKey = getPostAdminBanUnbanUserMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminBanUnbanUser>>, PostAdminBanUnbanUserMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postAdminBanUnbanUser(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminBanUnbanUserMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminBanUnbanUser>>>
    export type PostAdminBanUnbanUserMutationBody = BanUnbanUserRequest | undefined
    export type PostAdminBanUnbanUserMutationError = ErrorResult | ProblemDetails
    export type PostAdminBanUnbanUserMutationVariables = {data?: BanUnbanUserRequest}

    /**
 * @summary Bans or unbans a user (dbo.CMBanUnbanUser). Site admins or community managers.
 */
export const usePostAdminBanUnbanUser = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminBanUnbanUser>>, TError,PostAdminBanUnbanUserMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminBanUnbanUser>>,
        TError,
        PostAdminBanUnbanUserMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminBanUnbanUserMutationOptions(options), queryClient);
    }
    /**
 * @summary Swaps the divisions of two teams in the same league (dbo.CMSwapTeams). Site admins or community managers.
 */
export const postAdminSwapTeamDivisions = (
    swapTeamDivisionsRequest?: SwapTeamDivisionsRequest,
 signal?: AbortSignal
) => {


      return fetcher<AdminActionResult>(
      {url: `/Admin/SwapTeamDivisions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: swapTeamDivisionsRequest, signal
    },
      );
    }




export const getPostAdminSwapTeamDivisionsMutationKey = () => ['postAdminSwapTeamDivisions'] as const;

export const getPostAdminSwapTeamDivisionsMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminSwapTeamDivisions>>, TError,PostAdminSwapTeamDivisionsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminSwapTeamDivisions>>, TError,PostAdminSwapTeamDivisionsMutationVariables, TContext> => {

const mutationKey = getPostAdminSwapTeamDivisionsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminSwapTeamDivisions>>, PostAdminSwapTeamDivisionsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postAdminSwapTeamDivisions(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminSwapTeamDivisionsMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminSwapTeamDivisions>>>
    export type PostAdminSwapTeamDivisionsMutationBody = SwapTeamDivisionsRequest | undefined
    export type PostAdminSwapTeamDivisionsMutationError = ErrorResult | ProblemDetails
    export type PostAdminSwapTeamDivisionsMutationVariables = {data?: SwapTeamDivisionsRequest}

    /**
 * @summary Swaps the divisions of two teams in the same league (dbo.CMSwapTeams). Site admins or community managers.
 */
export const usePostAdminSwapTeamDivisions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminSwapTeamDivisions>>, TError,PostAdminSwapTeamDivisionsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminSwapTeamDivisions>>,
        TError,
        PostAdminSwapTeamDivisionsMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminSwapTeamDivisionsMutationOptions(options), queryClient);
    }
    /**
 * @summary Renames a team's city, name, and abbreviation (dbo.TeamRename). Site admins or community managers.
 */
export const postAdminRenameTeam = (
    renameTeamRequest?: RenameTeamRequest,
 signal?: AbortSignal
) => {


      return fetcher<AdminActionResult>(
      {url: `/Admin/RenameTeam`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: renameTeamRequest, signal
    },
      );
    }




export const getPostAdminRenameTeamMutationKey = () => ['postAdminRenameTeam'] as const;

export const getPostAdminRenameTeamMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRenameTeam>>, TError,PostAdminRenameTeamMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminRenameTeam>>, TError,PostAdminRenameTeamMutationVariables, TContext> => {

const mutationKey = getPostAdminRenameTeamMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminRenameTeam>>, PostAdminRenameTeamMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postAdminRenameTeam(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminRenameTeamMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminRenameTeam>>>
    export type PostAdminRenameTeamMutationBody = RenameTeamRequest | undefined
    export type PostAdminRenameTeamMutationError = ErrorResult | ProblemDetails
    export type PostAdminRenameTeamMutationVariables = {data?: RenameTeamRequest}

    /**
 * @summary Renames a team's city, name, and abbreviation (dbo.TeamRename). Site admins or community managers.
 */
export const usePostAdminRenameTeam = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRenameTeam>>, TError,PostAdminRenameTeamMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminRenameTeam>>,
        TError,
        PostAdminRenameTeamMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminRenameTeamMutationOptions(options), queryClient);
    }
    /**
 * @summary Generates custom free-agent players in a league (dbo.LeagueCreateFreeAgents). Site admins or community managers.
 */
export const postAdminCreateFreeAgents = (
    createFreeAgentsRequest?: CreateFreeAgentsRequest,
 signal?: AbortSignal
) => {


      return fetcher<AdminActionResult>(
      {url: `/Admin/CreateFreeAgents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createFreeAgentsRequest, signal
    },
      );
    }




export const getPostAdminCreateFreeAgentsMutationKey = () => ['postAdminCreateFreeAgents'] as const;

export const getPostAdminCreateFreeAgentsMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreateFreeAgents>>, TError,PostAdminCreateFreeAgentsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminCreateFreeAgents>>, TError,PostAdminCreateFreeAgentsMutationVariables, TContext> => {

const mutationKey = getPostAdminCreateFreeAgentsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminCreateFreeAgents>>, PostAdminCreateFreeAgentsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postAdminCreateFreeAgents(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminCreateFreeAgentsMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminCreateFreeAgents>>>
    export type PostAdminCreateFreeAgentsMutationBody = CreateFreeAgentsRequest | undefined
    export type PostAdminCreateFreeAgentsMutationError = ErrorResult | ProblemDetails
    export type PostAdminCreateFreeAgentsMutationVariables = {data?: CreateFreeAgentsRequest}

    /**
 * @summary Generates custom free-agent players in a league (dbo.LeagueCreateFreeAgents). Site admins or community managers.
 */
export const usePostAdminCreateFreeAgents = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreateFreeAgents>>, TError,PostAdminCreateFreeAgentsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminCreateFreeAgents>>,
        TError,
        PostAdminCreateFreeAgentsMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminCreateFreeAgentsMutationOptions(options), queryClient);
    }
    /**
 * @summary Every release note, drafts included, newest release first (no body). Site admins only.
 */
export const getAdminReleaseNotes = (

 signal?: AbortSignal
) => {


      return fetcher<ReleaseNoteAdminListResponse>(
      {url: `/Admin/ReleaseNotes`, method: 'GET', signal
    },
      );
    }




export const getGetAdminReleaseNotesQueryKey = () => {
    return [
    `/Admin/ReleaseNotes`
    ] as const;
    }


export const getGetAdminReleaseNotesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminReleaseNotes>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReleaseNotes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminReleaseNotesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminReleaseNotes>>> = ({ signal }) => getAdminReleaseNotes(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminReleaseNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminReleaseNotesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminReleaseNotes>>>
export type GetAdminReleaseNotesQueryError = ProblemDetails


export function useGetAdminReleaseNotes<TData = Awaited<ReturnType<typeof getAdminReleaseNotes>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReleaseNotes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminReleaseNotes>>,
          TError,
          Awaited<ReturnType<typeof getAdminReleaseNotes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminReleaseNotes<TData = Awaited<ReturnType<typeof getAdminReleaseNotes>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReleaseNotes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminReleaseNotes>>,
          TError,
          Awaited<ReturnType<typeof getAdminReleaseNotes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminReleaseNotes<TData = Awaited<ReturnType<typeof getAdminReleaseNotes>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReleaseNotes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every release note, drafts included, newest release first (no body). Site admins only.
 */

export function useGetAdminReleaseNotes<TData = Awaited<ReturnType<typeof getAdminReleaseNotes>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReleaseNotes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminReleaseNotesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary One release note at any status, with body, for the editor. Site admins only.
 */
export const getAdminReleaseNoteId = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<ReleaseNoteAdminDetail>(
      {url: `/Admin/ReleaseNote/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetAdminReleaseNoteIdQueryKey = (id: number,) => {
    return [
    `/Admin/ReleaseNote/${id}`
    ] as const;
    }


export const getGetAdminReleaseNoteIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminReleaseNoteId>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReleaseNoteId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminReleaseNoteIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminReleaseNoteId>>> = ({ signal }) => getAdminReleaseNoteId(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminReleaseNoteId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminReleaseNoteIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminReleaseNoteId>>>
export type GetAdminReleaseNoteIdQueryError = ProblemDetails


export function useGetAdminReleaseNoteId<TData = Awaited<ReturnType<typeof getAdminReleaseNoteId>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReleaseNoteId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminReleaseNoteId>>,
          TError,
          Awaited<ReturnType<typeof getAdminReleaseNoteId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminReleaseNoteId<TData = Awaited<ReturnType<typeof getAdminReleaseNoteId>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReleaseNoteId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminReleaseNoteId>>,
          TError,
          Awaited<ReturnType<typeof getAdminReleaseNoteId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminReleaseNoteId<TData = Awaited<ReturnType<typeof getAdminReleaseNoteId>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReleaseNoteId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One release note at any status, with body, for the editor. Site admins only.
 */

export function useGetAdminReleaseNoteId<TData = Awaited<ReturnType<typeof getAdminReleaseNoteId>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReleaseNoteId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminReleaseNoteIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Edits a release note at any status. A published note is updated in place and stays
published. Status is not changed here (use Publish / Unpublish). Site admins only.
 */
export const putAdminReleaseNoteId = (
    id: number,
    releaseNoteSaveRequest?: ReleaseNoteSaveRequest,
 signal?: AbortSignal
) => {


      return fetcher<ReleaseNoteAdminDetail>(
      {url: `/Admin/ReleaseNote/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: releaseNoteSaveRequest, signal
    },
      );
    }




export const getPutAdminReleaseNoteIdMutationKey = () => ['putAdminReleaseNoteId'] as const;

export const getPutAdminReleaseNoteIdMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminReleaseNoteId>>, TError,PutAdminReleaseNoteIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminReleaseNoteId>>, TError,PutAdminReleaseNoteIdMutationVariables, TContext> => {

const mutationKey = getPutAdminReleaseNoteIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminReleaseNoteId>>, PutAdminReleaseNoteIdMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminReleaseNoteId(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutAdminReleaseNoteIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminReleaseNoteId>>>
    export type PutAdminReleaseNoteIdMutationBody = ReleaseNoteSaveRequest | undefined
    export type PutAdminReleaseNoteIdMutationError = ErrorResult | ProblemDetails
    export type PutAdminReleaseNoteIdMutationVariables = {id: number;data?: ReleaseNoteSaveRequest}

    /**
 * @summary Edits a release note at any status. A published note is updated in place and stays
published. Status is not changed here (use Publish / Unpublish). Site admins only.
 */
export const usePutAdminReleaseNoteId = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminReleaseNoteId>>, TError,PutAdminReleaseNoteIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminReleaseNoteId>>,
        TError,
        PutAdminReleaseNoteIdMutationVariables,
        TContext
      > => {
      return useMutation(getPutAdminReleaseNoteIdMutationOptions(options), queryClient);
    }
    /**
 * @summary Deletes a DRAFT release note. 409 for a published note (unpublish it first). Site admins only.
 */
export const deleteAdminReleaseNoteId = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Admin/ReleaseNote/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAdminReleaseNoteIdMutationKey = () => ['deleteAdminReleaseNoteId'] as const;

export const getDeleteAdminReleaseNoteIdMutationOptions = <TError = ProblemDetails | ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminReleaseNoteId>>, TError,DeleteAdminReleaseNoteIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminReleaseNoteId>>, TError,DeleteAdminReleaseNoteIdMutationVariables, TContext> => {

const mutationKey = getDeleteAdminReleaseNoteIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminReleaseNoteId>>, DeleteAdminReleaseNoteIdMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminReleaseNoteId(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminReleaseNoteIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminReleaseNoteId>>>

    export type DeleteAdminReleaseNoteIdMutationError = ProblemDetails | ErrorResult
    export type DeleteAdminReleaseNoteIdMutationVariables = {id: number}

    /**
 * @summary Deletes a DRAFT release note. 409 for a published note (unpublish it first). Site admins only.
 */
export const useDeleteAdminReleaseNoteId = <TError = ProblemDetails | ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminReleaseNoteId>>, TError,DeleteAdminReleaseNoteIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminReleaseNoteId>>,
        TError,
        DeleteAdminReleaseNoteIdMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAdminReleaseNoteIdMutationOptions(options), queryClient);
    }
    /**
 * @summary Creates a release note as a Draft. Site admins only.
 */
export const postAdminReleaseNote = (
    releaseNoteSaveRequest?: ReleaseNoteSaveRequest,
 signal?: AbortSignal
) => {


      return fetcher<ReleaseNoteAdminDetail>(
      {url: `/Admin/ReleaseNote`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: releaseNoteSaveRequest, signal
    },
      );
    }




export const getPostAdminReleaseNoteMutationKey = () => ['postAdminReleaseNote'] as const;

export const getPostAdminReleaseNoteMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminReleaseNote>>, TError,PostAdminReleaseNoteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminReleaseNote>>, TError,PostAdminReleaseNoteMutationVariables, TContext> => {

const mutationKey = getPostAdminReleaseNoteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminReleaseNote>>, PostAdminReleaseNoteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postAdminReleaseNote(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminReleaseNoteMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminReleaseNote>>>
    export type PostAdminReleaseNoteMutationBody = ReleaseNoteSaveRequest | undefined
    export type PostAdminReleaseNoteMutationError = ErrorResult | ProblemDetails
    export type PostAdminReleaseNoteMutationVariables = {data?: ReleaseNoteSaveRequest}

    /**
 * @summary Creates a release note as a Draft. Site admins only.
 */
export const usePostAdminReleaseNote = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminReleaseNote>>, TError,PostAdminReleaseNoteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminReleaseNote>>,
        TError,
        PostAdminReleaseNoteMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminReleaseNoteMutationOptions(options), queryClient);
    }
    /**
 * @summary Publishes a release note. It goes live immediately; nothing else is sent. Site admins only.
 */
export const postAdminReleaseNoteIdPublish = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Admin/ReleaseNote/${id}/Publish`, method: 'POST', signal
    },
      );
    }




export const getPostAdminReleaseNoteIdPublishMutationKey = () => ['postAdminReleaseNoteIdPublish'] as const;

export const getPostAdminReleaseNoteIdPublishMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminReleaseNoteIdPublish>>, TError,PostAdminReleaseNoteIdPublishMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminReleaseNoteIdPublish>>, TError,PostAdminReleaseNoteIdPublishMutationVariables, TContext> => {

const mutationKey = getPostAdminReleaseNoteIdPublishMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminReleaseNoteIdPublish>>, PostAdminReleaseNoteIdPublishMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  postAdminReleaseNoteIdPublish(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminReleaseNoteIdPublishMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminReleaseNoteIdPublish>>>

    export type PostAdminReleaseNoteIdPublishMutationError = ProblemDetails
    export type PostAdminReleaseNoteIdPublishMutationVariables = {id: number}

    /**
 * @summary Publishes a release note. It goes live immediately; nothing else is sent. Site admins only.
 */
export const usePostAdminReleaseNoteIdPublish = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminReleaseNoteIdPublish>>, TError,PostAdminReleaseNoteIdPublishMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminReleaseNoteIdPublish>>,
        TError,
        PostAdminReleaseNoteIdPublishMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminReleaseNoteIdPublishMutationOptions(options), queryClient);
    }
    /**
 * @summary Returns a published note to Draft (first-publish time is kept). Site admins only.
 */
export const postAdminReleaseNoteIdUnpublish = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Admin/ReleaseNote/${id}/Unpublish`, method: 'POST', signal
    },
      );
    }




export const getPostAdminReleaseNoteIdUnpublishMutationKey = () => ['postAdminReleaseNoteIdUnpublish'] as const;

export const getPostAdminReleaseNoteIdUnpublishMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminReleaseNoteIdUnpublish>>, TError,PostAdminReleaseNoteIdUnpublishMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminReleaseNoteIdUnpublish>>, TError,PostAdminReleaseNoteIdUnpublishMutationVariables, TContext> => {

const mutationKey = getPostAdminReleaseNoteIdUnpublishMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminReleaseNoteIdUnpublish>>, PostAdminReleaseNoteIdUnpublishMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  postAdminReleaseNoteIdUnpublish(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminReleaseNoteIdUnpublishMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminReleaseNoteIdUnpublish>>>

    export type PostAdminReleaseNoteIdUnpublishMutationError = ProblemDetails
    export type PostAdminReleaseNoteIdUnpublishMutationVariables = {id: number}

    /**
 * @summary Returns a published note to Draft (first-publish time is kept). Site admins only.
 */
export const usePostAdminReleaseNoteIdUnpublish = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminReleaseNoteIdUnpublish>>, TError,PostAdminReleaseNoteIdUnpublishMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminReleaseNoteIdUnpublish>>,
        TError,
        PostAdminReleaseNoteIdUnpublishMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminReleaseNoteIdUnpublishMutationOptions(options), queryClient);
    }
    /**
 * @summary Held/stuck and recent league sims with per-step status. Site admins only.
 */
export const getAdminSimHealth = (

 signal?: AbortSignal
) => {


      return fetcher<SimHealthResponse>(
      {url: `/Admin/SimHealth`, method: 'GET', signal
    },
      );
    }




export const getGetAdminSimHealthQueryKey = () => {
    return [
    `/Admin/SimHealth`
    ] as const;
    }


export const getGetAdminSimHealthQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSimHealth>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSimHealth>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSimHealthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSimHealth>>> = ({ signal }) => getAdminSimHealth(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSimHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminSimHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSimHealth>>>
export type GetAdminSimHealthQueryError = ProblemDetails


export function useGetAdminSimHealth<TData = Awaited<ReturnType<typeof getAdminSimHealth>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSimHealth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSimHealth>>,
          TError,
          Awaited<ReturnType<typeof getAdminSimHealth>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSimHealth<TData = Awaited<ReturnType<typeof getAdminSimHealth>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSimHealth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSimHealth>>,
          TError,
          Awaited<ReturnType<typeof getAdminSimHealth>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSimHealth<TData = Awaited<ReturnType<typeof getAdminSimHealth>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSimHealth>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Held/stuck and recent league sims with per-step status. Site admins only.
 */

export function useGetAdminSimHealth<TData = Awaited<ReturnType<typeof getAdminSimHealth>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSimHealth>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminSimHealthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Resumes a held sim from its failed step (dbo procs untouched). Site admins only.
 */
export const postAdminSimHealthSimResultIdResume = (
    simResultId: number,
 signal?: AbortSignal
) => {


      return fetcher<AdminActionResult>(
      {url: `/Admin/SimHealth/${simResultId}/Resume`, method: 'POST', signal
    },
      );
    }




export const getPostAdminSimHealthSimResultIdResumeMutationKey = () => ['postAdminSimHealthSimResultIdResume'] as const;

export const getPostAdminSimHealthSimResultIdResumeMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminSimHealthSimResultIdResume>>, TError,PostAdminSimHealthSimResultIdResumeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminSimHealthSimResultIdResume>>, TError,PostAdminSimHealthSimResultIdResumeMutationVariables, TContext> => {

const mutationKey = getPostAdminSimHealthSimResultIdResumeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminSimHealthSimResultIdResume>>, PostAdminSimHealthSimResultIdResumeMutationVariables> = (props) => {
          const {simResultId} = props ?? {};

          return  postAdminSimHealthSimResultIdResume(simResultId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAdminSimHealthSimResultIdResumeMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminSimHealthSimResultIdResume>>>

    export type PostAdminSimHealthSimResultIdResumeMutationError = ErrorResult | ProblemDetails
    export type PostAdminSimHealthSimResultIdResumeMutationVariables = {simResultId: number}

    /**
 * @summary Resumes a held sim from its failed step (dbo procs untouched). Site admins only.
 */
export const usePostAdminSimHealthSimResultIdResume = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminSimHealthSimResultIdResume>>, TError,PostAdminSimHealthSimResultIdResumeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminSimHealthSimResultIdResume>>,
        TError,
        PostAdminSimHealthSimResultIdResumeMutationVariables,
        TContext
      > => {
      return useMutation(getPostAdminSimHealthSimResultIdResumeMutationOptions(options), queryClient);
    }
